"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actionTypes = void 0;
var actionTypes = {
  ADD_SESSION_SITE: "@@analytic-session/add-session-site",
  ADD_SESSION_REPORT: "@@analytic-session/add-session-report",
  DELETE: "@@analytic-session/delete-sessio",
  FETCH_RECORDING: "@@analytic-session/fetch-recording",
  RESET: "@@analytic-session/reset",
  SUCCESS: "@@analytic-session/success",
  ERROR: "@@analytic-session/error",
  CHANGE_LOG_VIEW_DETAILS: "@@analytic-session/change-log-view-details",
  DOWNLOAD_CHANGE_LOG_VERSION_FILE: "@@analytic-session/download-change-log-version-file"
};
exports.actionTypes = actionTypes;